module.exports = __webpack_public_path__ + "img/gsb9.cbc039be.png";